import React from 'react';
import { useSelector } from 'react-redux';

import { BequestCard } from 'modules/asset/components';
import { Row, Col } from 'modules/bootstrap/components';

import { QUESTIONNAIRE_KEYS } from 'modules/assistant/constants/questionnaires';
import {
  WILL_GENERATOR_ANSWER_KEYS,
  STEP_KEYS,
} from 'modules/assistant/constants/questionnaires/will';

export interface BequestEndProps {
  bequests: any;
}

export default function BequestEnd({ bequests }: BequestEndProps) {
  const questionnaireData = useSelector(
    (state: any) => state.questionnaires[QUESTIONNAIRE_KEYS.WILL_GENERATOR]
  );
  const typeOfWill = questionnaireData[STEP_KEYS.STEP_10];
  const isSpousalWill = typeOfWill === WILL_GENERATOR_ANSWER_KEYS.SPOUSAL;
  return (
    <Row style={{ marginTop: 10 }}>
      {bequests.map((item, idx) => (
        <Col sm={10} md={5} key={`${item.bequest}_${idx}`}>
          <BequestCard
            isDropdownMenuHidden
            bequestData={item}
            isSpousalWill={isSpousalWill}
          />
        </Col>
      ))}
    </Row>
  );
}
